import type { Swiper as SwiperType } from 'swiper';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import SEO from '../components/SEO/SEO';
import MobileNav from '../components/Navigations/mobileNav';
import Nav from '../components/Navigations/desktopNav';
import Header from '../layout/client-side/home';

const Index = () => {
  const location = useLocation();
  const [swiper, setSwiper] = useState<SwiperType | null>(null);

  useEffect(() => {
    if (swiper && location.state?.slide !== undefined) {
      swiper.slideTo(location.state.slide);
    }
  }, [swiper, location.state]);

  return (
    <>
      <SEO
        title="AirSolutions Belgium - Uw partner voor airconditioning en koeltechniek"
        description="Ontdek AirSolutions Belgium, uw betrouwbare partner voor airconditioning en koeltechniek. Wij bieden op maat gemaakte oplossingen voor residentiële en commerciële toepassingen."
        keywords="AirSolutions, airconditioning, koeltechniek, HVAC, residentieel, commercieel"
        canonical="/home"
      />
      <MobileNav />
      <Nav swiper={swiper} />
      <Header setSwiper={setSwiper} />
    </>
  );
};

export default Index;
